import React, { useState } from "react";
import Style from "./TaxiCurrentTraverlDetail.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressBook,
  faCoins,
  faMapPin,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { separate } from "../../Functions/NumberSeprator";
import { TaxiReqApi } from "../../Api/DeliveryBarest";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";
const TaxiCurrentTraverlDetail = ({ detail, updateReq }) => {
  const history = useHistory();
  const [modalShow, setModalShow] = useState(false);
  const OpenMapHandler = (location) => {
    window.open(
      `https://maps.apple.com/?q=${location.split(",")[1]},${
        location.split(",")[0]
      }`
    );
  };
  const cancleHandler = () => {
    let info = {
      id: detail.id,
      action: "cancel",
      cause: "for action cancel",
    };
    TaxiReqApi(info, (res) => {
      if (res.status === 1) {
        succToast("سفرشما کنسل شد!");
        setModalShow(false);
        updateReq();
      } else {
        errorToast(res.message);
      }
    });
  };
  const situationHandler = () => {
    if (detail.status === "3") {
    }
    let info = {
      id: detail.id,
      action:
        detail.status === "1"
          ? "arrive"
          : detail.status === "2"
          ? "getting_in"
          : detail.status === "3"
          ? "finish"
          : null,
    };
    TaxiReqApi(info, (res) => {
      if (res.status === 1) {
        succToast("بروز رسانی وضعیت انجام شد!");
        updateReq();
        if (detail.status === "3") {
          history.push("./taxireq");
        }
      } else {
        errorToast(res.message);
      }
    });
  };
  return (
    <>
      {detail ? (
        <div className={Style.ComponentHolder}>
          {modalShow ? (
            <section className={Style.modalbakdrop}>
              <div className={Style.modalContainer}>
                <h2>سفر موردنظر کنسل شود؟</h2>
                <div className={Style.modalBtn}>
                  <button style={{ background: "red" }} onClick={cancleHandler}>
                    بله
                  </button>
                  <button
                    style={{ background: "green" }}
                    onClick={() => setModalShow(false)}
                  >
                    خیر
                  </button>
                </div>
              </div>
            </section>
          ) : null}
          <address className={Style.AddressHolder}>
            <FontAwesomeIcon icon={faMapPin} color="#b00064" />
            <p>مبدا:{detail?.routes_description.split("**")[0]}</p>
          </address>
          <address className={Style.AddressHolder}>
            <FontAwesomeIcon
              icon={faMapPin}
              color="#b00064"
            />
            <p>مقصد: {detail?.routes_description.split("**")[1]}</p>
          </address>
          <address className={Style.AddressHolder}>
            <FontAwesomeIcon
              icon={faMapPin}
              color="#b00064"
            />
            <p>مقصد دوم: {detail?.routes_description.split("**")[2]}</p>
          </address>
          {detail?.description && (
            <address className={Style.AddressHolder}>
              <FontAwesomeIcon icon={faAddressBook} color="#b00064" />
              <p>توضیحات: {detail?.description}</p>
            </address>
          )}
          <button
            className={Style.BtnAddress}
            onClick={() => OpenMapHandler(detail?.routes.split("-")[0])}
          >
            نمایش موقعیت مبدا روی نقشه
          </button>
          <button
            className={Style.BtnAddress}
            onClick={() => OpenMapHandler(detail?.routes.split("-")[1])}
          >
            نمایش موقعیت مقصد روی نقشه
          </button>
          {detail?.routes.split("-")[2]&&<button
            className={Style.BtnAddress}
            onClick={() => OpenMapHandler(detail?.routes.split("-")[2])}
          >
            نمایش موقعیت مقصد دوم روی نقشه
          </button>}
          <p className={Style.passengerHolder}>
            <FontAwesomeIcon icon={"money-bill"} color="#15a2fa" />
            {` وضعیت پرداخت: ${
              detail.paid !== "0" ? "پرداخت شده" : "پرداخت نشده!"
            }`}
          </p>
          <p className={Style.passengerHolder}>
            <FontAwesomeIcon icon={faUser} color="#15a2fa" />
            {detail?.name}
            <a className={Style.CallUserHolder} href={`tel:${detail?.phone}`}>
              <FontAwesomeIcon icon={faPhone} color="green" />
            </a>
          </p>
          <p className={Style.PriceHolder}>
            <FontAwesomeIcon icon={faCoins} color="#00d463" />
            {`کرایه :${separate(detail?.delivery)} تومان`}
          </p>
          <button className={Style.acceptBtn} onClick={situationHandler}>
            {detail?.status === "1"
              ? "به مبدأ رسیدم"
              : detail?.status === "2"
              ? "مسافر سوارشد"
              : "اتمام سفر"}
          </button>
          {detail?.status === "1" ? (
            <button
              className={Style.cancleBtn}
              onClick={() => setModalShow(true)}
            >
              کنسل کردن
            </button>
          ) : null}
        </div>
      ) :         <div className={Style.NotOrderFoundHolder}>
      <div className={Style.ImageBasket}>
        <img src="/Assets/Images/Order/emtyOreder.svg" alt="barest" />
      </div>
      <p className={Style.NoOrderText}>هنوز سفری قبول نکرده اید!</p>
    </div>}
    </>
  );
};

export default TaxiCurrentTraverlDetail;
